import React, { useState, useEffect, forwardRef } from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    DialogContentText,
    DialogTitle,
    Slide,
    FormControlLabel,
    Checkbox
} from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { Grid, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CommonPrint from 'Components/Print/CommonPrint';
import { SelectFormByKey as SELECT_BY_KEY } from 'Components/Api/RichTextMediaAPI';
import { InsertUser as INSERT_USER } from 'Components/Api/AgreementAPI';
import { VerifyOTP as VERIFY_OTP } from 'Components/Api/AgreementAPI';
import { Select as SELECT } from 'Components/Api/AgreementAPI';
import { OTPModal } from 'Components/Modal/OTPModal';
const useStyles = makeStyles((theme) => ({
    marginTab: {
        padding: '0px',
        paddingTop: '24px',
        marginRight: '-18px'
    },
    borderPaper: {
        border: '1px solid'
    },
    appBarHeight: {
        height: 50
    },
    p10: {
        padding: 10
    },
    document_h3: {
        fontWeight: 'normal',
        fontSize: 30
    },
    document_h2: {
        fontWeight: 'bold',
        fontSize: 35
    },
    blue_h4: {
        color: '#481BAB',
        fontWeight: 'bold',
        fontSize: 16
    },

    method: {
        fontSize: 16,
        color: '#FFA500',
        fontWeight: 'bold'
    },
    response: {
        fontSize: 16,
        color: '#00807A',
        fontWeight: 'bold'
    },
    center: {
        textAlign: 'center',
        margin: '4px'
    },

    center1: {
        textAlign: 'center',
        margin: '4px',
        fontWeight: 'bold'
    }
}));

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function AgreementFormPrint({
    isOpen,
    title,
    positiveButtonTitle,
    positiveButtonClick,
    negativeButtonTitle,
    negativeButtonClick
}) {
    const [open, setOpen] = useState(isOpen);
    const [isError, setIsError] = useState('');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [otpDisplayed, setOtpDisplayed] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [OTPMasterID, setOTPMasterID] = useState(0);
    const [OpenOTP, setOpenOTP] = useState(0);
    const [modalErrorMessage, setModalErrorMessage] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [isUserVerified, setIsUserVerified] = useState(false);

    const [otp, setOtp] = useState('');
    const [isOtpDialogOpen, setIsOtpDialogOpen] = useState(false);
    const [isAgreementStatus, setAgreementStatus] = useState(false);
    const [loading, setLoading] = useState(true);
    const classes = commonStyle();

    const handleNegativeButtonClick = () => {
        setOpen(false);
        negativeButtonClick();
    };
    const handlePositiveButtonClick = () => {
        /// window.print();
        let pageSize = 'A4';
        CommonPrint(pageSize);
    };
    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };
    const handleSubmitButtonClick = async () => {
        const response = await INSERT_USER();
        if (!response.isAuthorized) LOGOUT();

        setIsError(true);

        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) {
            setSeverity('error');
            setLoading(false);
            return;
        }

        var data = JSON.parse(response.data);
        setOtpDisplayed(true);
        setOpenOTP(true);

        setSeverity('success');
        setResponseMessage(data.Message);
        setIsError(true);
        setOTPMasterID(data.OTPMasterID);
    };

    const VerifyAgreementSubmitOTP = async (otpObj) => {
        setLoadingOpen(true);
        setOpenOTP(false);
        setModalErrorMessage('');

        const { OTP } = otpObj;

        let RequestObj = {
            OTP: OTP,
            OTPMasterID: OTPMasterID
        };

        var requestObj = JSON.stringify(RequestObj);
        var response = await VERIFY_OTP(requestObj);

        setLoadingOpen(false);

        if (!response.status) {
            setLoadingOpen(false);
            var data = JSON.parse(response.data);
            setModalErrorMessage(data.Message);
            return;
        }

        var data = JSON.parse(response.data);
        setSeverity('success');
        setResponseMessage(data.Message);
        setIsError(true);
        setOpenOTP(false);

        setOTPMasterID(0);
    };

    const CheckUserIsExists = async () => {
        setLoading(true);
        try {
            const response = await SELECT();

            if (response.status) {
                var data = JSON.parse(response.data);
                setIsUserVerified(data.isVerified);
                setAgreementStatus(data.AgreementStatus);
            }
        } catch (error) {
            console.error('Error', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        CheckUserIsExists();
    }, [OTPMasterID]);

    return (
        <>
            <Dialog
                //fullWidth
                maxWidth="lg"
                open={open}
                onClose={() => {
                    setOpen(false);
                    negativeButtonClick(false);
                }}
                TransitionComponent={Transition}
            >
                <DialogTitle id="alert-dialog-title" className={classes.title}>
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="DialogPrint">
                        <AgreementPrint />
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    displayPrint="none"
                    style={{ display: 'initial' }}
                >
                    <Grid
                        container
                        spacing={1}
                        style={{ justifyContent: 'center' }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Button
                                onClick={handleNegativeButtonClick}
                                className={
                                    classes.CustomSecondaryButtonStylePopup
                                }
                            >
                                {negativeButtonTitle
                                    ? negativeButtonTitle
                                    : 'No, Cancel Print'}
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Button
                                onClick={handlePositiveButtonClick}
                                className={
                                    classes.CustomPrimaryButtonStylePopup
                                }
                            >
                                {positiveButtonTitle
                                    ? positiveButtonTitle
                                    : 'Yes, Do Print'}
                            </Button>
                        </Grid>
                        {isAgreementStatus && (
                            <Grid
                                container
                                spacing={1}
                                style={{ justifyContent: 'center' }}
                            >
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={isChecked}
                                                onChange={handleCheckboxChange}
                                                name="agreement"
                                                color="primary"
                                            />
                                        }
                                        label="I Agree All Terms And Condition"
                                    />
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                    <>
                        {isChecked && (
                            <Grid
                                container
                                style={{ justifyContent: 'center' }}
                            >
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        justifyContent: 'center',
                                        display: 'flex'
                                    }}
                                >
                                    <Button
                                        onClick={handleSubmitButtonClick}
                                        style={{
                                            background: '#0000FF',
                                            color: '#fff'
                                        }}
                                    >
                                        SUBMIT
                                    </Button>
                                </Grid>
                            </Grid>
                        )}
                    </>
                </DialogActions>
            </Dialog>

            {OpenOTP ? (
                <OTPModal
                    isOpen={OpenOTP}
                    title="OTP"
                    error={modalErrorMessage}
                    submitCallback={(value) => {
                        VerifyAgreementSubmitOTP(value);
                    }}
                    resendCallback={() => {}}
                    onDismissCallback={(value) => {
                        setOpenOTP(value);
                    }}
                />
            ) : null}
        </>
    );
}

const AgreementPrint = () => {
    const [isContentDisplay, setIsContentDisplay] = useState(false);
    const [content, setContent] = useState('');
    const [UserID, setUserID] = useState(localStorage.getItem('UserID'));
    const [Address, setAddress] = useState('');
    const [PersonName, setPersonName] = useState('');
    const [StateName, setStateName] = useState('');
    const [PANNo, setPANNo] = useState('');
    const [MobileNumber, setMobileNumber] = useState('');
    const [FirmName, setFirmName] = useState('');
    const [AadharNo, setAadharNo] = useState('');
    const [City, setCity] = useState('');
    const [GSTNo, setGSTNo] = useState('');
    const SelectFormByKey = async () => {
        setIsContentDisplay(false);
        var reqObj = JSON.stringify({
            Key: 'AgreementForm'
        });

        var response = await SELECT_BY_KEY(reqObj);
        if (!response.isAuthorized) LOGOUT();
        if (!response.status) {
            return;
        }
        var data = JSON.parse(response.data);

        if (data.Content == null || data.Content.length <= 3) {
            setAddress(data.Address);
            setPersonName(data.PersonName);
            setFirmName(data.FirmName);
            setAadharNo(data.AadharNo);
            setMobileNumber(data.MobileNumber);
            setPANNo(data.PANNo);
            setCity(data.City);
            setStateName(data.StateName);
            setGSTNo(data.GSTNo);
        }

        setContent(data.Content);
        setIsContentDisplay(true);
    };

    useEffect(() => {
        SelectFormByKey();
    }, []);

    if (isContentDisplay)
        return (
            <div
                class="form"
                dangerouslySetInnerHTML={{
                    __html: content
                }}
            />
        );

    return (
        <Paper
            style={{
                border: '1px solid',
                padding: 10,
                margin: '1%',
                marginRight: '15%'
            }}
        >
            <Grid
                container
                spacing={2}
                style={{
                    padding: 10,
                    lineHeight: 1.4
                }}
            >
                <Grid item xs={12} sm={12} md={8} lg={8}>
                    <h3
                        style={{
                            fontWeight: 'normal',
                            fontSize: 20,
                            fontWeight: 'bold'
                        }}
                    >
                        AGREEMENT FORM
                    </h3>

                    <h6>
                        {PersonName} UNDER THE DISTRIBUTOR {FirmName}
                    </h6>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <p>
                        PAN : {PANNo}
                        <br />
                        AdharNo: {AadharNo}
                        <br />
                        MobileNo : {MobileNumber}
                        <br />
                        Address: {Address}
                        <br />
                        State: {StateName}
                        <br />
                        City: {City}
                        <br />
                        GSTNo : {GSTNo}
                    </p>
                </Grid>
            </Grid>
        </Paper>
    );
};
